<template>
  <div class="enhanced-container">
    <!-- 頂部導航 -->
    <div class="enhanced-header">
      <div class="header-content">
        <el-button icon="el-icon-arrow-left" @click="close" circle class="nav-btn"></el-button>
        <h1 class="header-title">充值記錄</h1>
        <el-button icon="el-icon-refresh" @click="getLogData" circle class="nav-btn"></el-button>
      </div>
    </div>

    <!-- 主要內容 -->
    <div class="enhanced-content">
      <!-- 訂單卡片 -->
      <div v-for="order in paginatedData" :key="order.id" class="enhanced-card" :class="`status-${order.status}`">
        <div class="card-corner"></div>
        <div class="card-content">
          <div class="card-main">
            <div class="order-meta">
              <span class="order-id">#{{ order.id }}</span>
              <div class="status-badge">
                {{ order.statusText }}
              </div>
            </div>
            <div class="amount-display">
              <span class="currency">HKD</span>
              <span class="amount">{{ Number(order.amount / 100).toFixed(2) }}</span>
            </div>
          </div>

          <div class="divider"></div>

          <div class="order-details">
            <div class="detail-item">
              <span class="detail-label">支付方式</span>
              <span class="detail-value">{{ order.pay_type }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">創建時間</span>
              <span class="detail-value">{{ formatTimestamp(order.create_at) }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 分頁 -->
      <div style="display: flex; justify-content: center; padding-bottom: 20px;">
        <el-pagination background @current-change="handlePageChange" :current-page="currentPage" :page-size="pageSize"
        :total="total" layout="prev, pager, next" :pager-count="5" class="enhanced-pagination">
      </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentPage: 1,
      pageSize: 6,
      total: 17,
      orders: []
    }
  },
  computed: {
    paginatedData() {
      return this.orders.map(order => ({
        ...order,
        statusText: this.getStatusText(order.status)
      }))
    }
  },
  mounted() {
    this.getLogData()
  },
  methods: {
    formatTimestamp(timestamp) {
    // 判斷傳入時間戳是秒級還是毫秒級
    // 如果是秒級（10位數字），則轉換為毫秒級
    if (timestamp.toString().length === 10) {
        timestamp = timestamp * 1000;
    }

    const date = new Date(timestamp);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份從0開始
    const day = String(date.getDate()).padStart(2, '0');

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
},
    handlePageChange(e) {
      this.currentPage = e
      this.getLogData()
    },
    getLogData() {
      this.$axios.get(`/api/pay_order/list?page=${this.currentPage}&perPage=${this.pageSize}`).then(res => {
        var d = res.data.data

        this.total = d.total
        this.orders = d.items

        console.log(d)
      })
    },
    close() {
      this.$router.go(-1);
    },
    getStatusText(status) {
      return {
        0: '未支付',
        1: '處理中',
        2: '充值成功'
      }[status] || '未知狀態'
    },
  }
}
</script>

<style scoped>
.enhanced-container {
  background: #f8fafc;
  min-height: 100vh;
}

.enhanced-header {
  background: white;
  box-shadow: 0 2px 8px rgba(18, 38, 63, 0.03);
  padding: 16px 24px;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-title {
  font-size: 20px;
  color: #2d3748;
  letter-spacing: 0.5px;
}

.nav-btn {
  width: 40px;
  height: 40px;
  font-size: 18px;
  border: none;
  box-shadow: 0 2px 6px rgba(18, 38, 63, 0.1);
}

.enhanced-content {
  max-width: 1200px;
  padding: 20px;
}

.enhanced-card {
  background: white;
  border-radius: 16px;
  margin-bottom: 20px;
  position: relative;
  overflow: hidden;
  transition: transform 0.2s, box-shadow 0.2s;
  border: 1px solid #e2e8f0;
}

.enhanced-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(18, 38, 63, 0.08);
}

.card-corner {
  position: absolute;
  top: 0;
  right: 0;
  width: 60px;
  height: 60px;
  background: linear-gradient(45deg, transparent 50%, rgba(66, 153, 225, 0.1) 50%);
}

.card-content {
  padding: 24px;
}

.order-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.order-id {
  color: #4a5568;
  font-size: 14px;
  font-family: monospace;
}

.status-badge {
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
}

.status-2 .status-badge {
  background: linear-gradient(45deg, #48bb78, #38a169);
  color: white;
}

.status-1 .status-badge {
  background: linear-gradient(45deg, #ecc94b, #d69e2e);
  color: white;
}

.status-0 .status-badge {
  background: linear-gradient(45deg, #f56565, #c53030);
  color: white;
}

.amount-display {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 24px;
}

.currency {
  color: #718096;
  font-size: 16px;
}

.amount {
  color: #2d3748;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.divider {
  height: 1px;
  background: #edf2f7;
  margin: 20px 0;
}

.order-details {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.detail-item {
  display: flex;
  flex-direction: column;
}

.detail-label {
  color: #718096;
  font-size: 12px;
  margin-bottom: 4px;
}

.detail-value {
  color: #4a5568;
  font-size: 14px;
  font-weight: 500;
}

.enhanced-pagination {
  margin-top: 40px;
  justify-content: center;
}

.enhanced-pagination>>>.el-pager li {
  border-radius: 8px;
  margin: 0 4px;
  font-weight: 500;
}

.enhanced-pagination>>>.el-pager li.active {
  background: linear-gradient(45deg, #4299e1, #3182ce);
}
</style>
